import { Dispatch, createContext } from 'react';

import { ConnectionSystem } from 'generated/graphql';
import {
    DEFAULT_INITIAL_PAGE_STATE,
    FormData,
    PageStateAction,
} from './formStateReducer';

export const PageStateContext = createContext<{
    selectedConnector: ConnectionSystem;
    formData: FormData;
}>(DEFAULT_INITIAL_PAGE_STATE);

export const PageStateDispatchContext =
    createContext<Dispatch<PageStateAction> | null>(null);
